module.exports = __webpack_public_path__ + "static/media/ic_cover_login.cc9e6029.png";